import React from 'react';
import { Button, Modal } from 'react-bootstrap';

export default function ConfirmationModal({
  isModalOpen,
  setIsModalOpen,
  title,
  body,
  handleConfirm,
  confirmationVariant,
}) {
  return (
    <Modal
      show={isModalOpen}
      onHide={() => setIsModalOpen(false)}
      backdrop="static"
      keyboard={false}
      centered
    >
      <Modal.Header closeButton>
        {title && <Modal.Title>{title}</Modal.Title>}
      </Modal.Header>
      {body && <Modal.Body>{body}</Modal.Body>}
      <Modal.Footer>
        <Button variant="secondary" onClick={() => setIsModalOpen(false)}>
          Close
        </Button>
        {handleConfirm && (
          <Button variant="primary" onClick={handleConfirm} className="pms-bg">
            Confirm
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
}
